<template>
    <v-card :color="color" dark class="fill-height">
      <v-card-title class="text-subtitle-1 py-2">
        {{ titulo }} 
        <v-spacer />
        <span class="text-subtitle-1">{{ tareas.length }}</span>
      </v-card-title>
      <v-card-subtitle class="pb-2">{{ subtitulo }}</v-card-subtitle>
      <v-card-text class="pt-0">
        <eisenhower-tarea
          v-for="tarea in tareas"
          :key="tarea.id"
          :tarea="tarea"
          @editar="$emit('editar', tarea)"
          @eliminar="$emit('eliminar', tarea)"
          @toggle-completada="$emit('toggle-completada', tarea)"
        />
        <p v-if="tareas.length === 0" class="text-caption ma-0">Sin tareas</p>
      </v-card-text>
    </v-card>
  </template>
  
  <script>
  import EisenhowerTarea from './EisenhowerTarea.vue'
  
  export default {
    name: 'EisenhowerQuadrante',
    components: { EisenhowerTarea },
    props: {
      titulo: { type: String, required: true },
      subtitulo: { type: String, default: '' },
      color: { type: String, default: 'grey' },
      tareas: { type: Array, default: () => [] }
    }
  }
  </script>